import type { SVGAttributes } from 'react';

export function DeutchIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_471_2158)">
				<path
					d="M0.496094 10.7826C1.62644 13.829 4.55878 16 7.9985 16C11.4382 16 14.3706 13.829 15.5009 10.7826L7.9985 10.087L0.496094 10.7826Z"
					fill="#FFDA44"
				/>
				<path
					d="M7.9985 0C4.55878 0 1.62644 2.171 0.496094 5.21741L7.9985 5.91303L15.5009 5.21737C14.3706 2.171 11.4382 0 7.9985 0Z"
					fill="black"
				/>
				<path
					d="M0.497594 5.21741C0.176031 6.08406 0 7.02144 0 8C0 8.97856 0.176031 9.91594 0.497594 10.7826H15.5024C15.824 9.91594 16 8.97856 16 8C16 7.02144 15.824 6.08406 15.5024 5.21741H0.497594Z"
					fill="#D80027"
				/>
			</g>
			<defs>
				<clipPath id="clip0_471_2158">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
